/*
 * Copyright (c) 2018. keni <$email>
 *
 * This file custom-magic-line-navigation.js is part of event_pass_client.dev.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential
 * custom-magic-line-navigation.js can not be copied and/or distributed
 * without the express permission of keni
 */

import {uniqueId} from '../../../../../app/Shared/Resources/Assets/js/helpers/classesAndIds';

import {_} from 'underscore';

let settingsRaw = {
	current_page_class: '.current_page_item',
	magic_line_id: '#magic-line-effect'
};

function initMagicLine(wrapper, options) {

	let settings = $.extend(settingsRaw, options, {});

	let el, leftPos, newWidth,
		magicLine = $(settings.magic_line),
		currentLink = $(settings.current_page);

	setup();
	watcher();
	function setup(){
		magicLine
			.width(currentLink.width())
			.css({
				left: currentLink.find('a').position().left
			})
			.data('origLeft', magicLine.position().left)
			.data('origWidth', magicLine.width())
			.animate({
				opacity: 1
			}, 600);
		// console.log('lineElm',lineElm,'magicLine',magicLine);


	}
	function watcher(){
		wrapper.find('li').find('a').hover(function () {

			el = $(this);

			leftPos = el.position().left;
			newWidth = el.parent().width();
			magicLine.stop().animate({
				left: leftPos,
				width: newWidth
			}, 250);
		}, function () {
			magicLine.stop().animate({
				left: magicLine.data('origLeft'),
				width: magicLine.data('origWidth')
			}, 800);
		});
	}

	$(window).resize(_.debounce(function(){
		setup();
	}, 500));
}

export default function magicLine(elm,options) {


	$('.magic-line').each(function () {
		if(!$(this).attr('id')){
			$(this).attr('id',uniqueId('magic_line_wrapper'))
		}

		initMagicLine($(this),options);
	});
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/effects/custom-magic-line-navigation.js